import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "components/navigation/ProtectedRoute";

// Pages
import InterviewDashboard from "../dashboard/interviewDashboardMain";
import ActiveInterviewSession from "../active-interview-session/activeInterviewSessionMain";
import PreparationGuide from "../preparation-guide/PreparationGuide";
import ResumeAnalysis from "../resume/analysis/ResumeAnalysis";
import ResumeFixed from "../resume/analysis/ResumeFixed";
import UserProfileSettings from "../user-profile-settings/userProfileSettingsMain";
import InterviewResultsHub from "../interview-results-hub/interviewResultsHubMain";
import MockTestInstructions from "../mock-test/MockTestInstructions";
import MockTestCamera from "../mock-test/MockTestCamera";
import MockTestEngine from "../mock-test/MockTestEngine";
import TestCompleted from "../mock-test/TestCompleted";
import Results from "../mock-test/Results";

import FullScreenGuard from "../mock-test/components/FullScreenGuard";
import TabSwitchGuard from "../mock-test/components/TabSwitchGuard";
import { ViolationProvider } from "../mock-test/components/ViolationContext";
import CompanyQuestions from "../add-question/CompanyQuestions";

import PastInterviewsPage from "../past-interviews/pastinterview";


// CORRECT
import ResumeEditor from "../resume/analysis/components/ResumeEditor";

const CandidateRoutes = () => {
  return (
    <Routes>

      {/* Dashboard */}
      <Route
        path="dashboard"
        element={
          <ProtectedRoute>
            <InterviewDashboard />
          </ProtectedRoute>
        }
      />

      {/* Resume Home */}
      <Route
        path="resume"
        element={
          <ProtectedRoute>
            <ResumeAnalysis />
          </ProtectedRoute>
        }
      />

      {/* Resume Analysis */}
      <Route
        path="resume/analysis"
        element={
          <ProtectedRoute>
            <ResumeAnalysis />
          </ProtectedRoute>
        }
      />

      {/* ✅ FIXED — Resume Editor (AI Improve Page) */}
      <Route
        path="resume/editor"
        element={
          <ProtectedRoute>
            <ResumeEditor />
          </ProtectedRoute>
        }
      />

      {/* Improved Resume Page */}
      <Route
        path="resume-fixed"
        element={
          <ProtectedRoute>
            <ResumeFixed />
          </ProtectedRoute>
        }
      />

      {/* Interview Session */}
      <Route
        path="active-interview-session"
        element={
          <ProtectedRoute>
            <ActiveInterviewSession />
          </ProtectedRoute>
        }
      />

      {/* Preparation Guide */}
      <Route
        path="preparation-guide"
        element={
          <ProtectedRoute>
            <PreparationGuide />
          </ProtectedRoute>
        }
      />

      {/* Profile Settings */}
      <Route
        path="user-profile-settings"
        element={
          <ProtectedRoute>
            <UserProfileSettings />
          </ProtectedRoute>
        }
      />

      {/* Interview Results */}
      <Route
        path="interview-results-hub"
        element={
          <ProtectedRoute>
            <InterviewResultsHub />
          </ProtectedRoute>
        }
      />

      {/* Past Interviews */}
      <Route
        path="past-interviews"
        element={
          <ProtectedRoute>
            <PastInterviewsPage />
          </ProtectedRoute>
        }
      />

      {/* Mock Test */}
      <Route path="mock-test/instructions" element={<MockTestInstructions />} />
      <Route path="mock-test/camera" element={<MockTestCamera />} />

      <Route
        path="mock-test/start"
        element={
          <ViolationProvider>
            <FullScreenGuard />
            <TabSwitchGuard />
            <MockTestEngine />
          </ViolationProvider>
        }
      />

      <Route path="mock-test/completed" element={<TestCompleted />} />

      <Route path="results" element={<Results />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="dashboard" replace />} />

    </Routes>
  );
};

export default CandidateRoutes;